import { render, staticRenderFns } from "./ListagemEnderecos.vue?vue&type=template&id=764bcd9d&scoped=true"
import script from "./ListagemEnderecos.vue?vue&type=script&lang=js"
export * from "./ListagemEnderecos.vue?vue&type=script&lang=js"
import style0 from "./ListagemEnderecos.vue?vue&type=style&index=0&id=764bcd9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764bcd9d",
  null
  
)

export default component.exports